export class SignableListAPIFilters {
  branchs: number[] = [];
  users: number[] = [];
}
